var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_16840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5176 9.14368L10.2422 11.4191V5.78906C10.2422 5.37915 9.9099 5.04688 9.49999 5.04688C9.09008 5.04688 8.7578 5.37915 8.7578 5.78906V11.4191L6.48233 9.14368C6.19251 8.85381 5.72255 8.85381 5.43273 9.14368C5.14287 9.43354 5.14287 9.90345 5.43273 10.1933C6.20961 10.9701 8.93229 13.6932 8.97983 13.74C9.27032 14.0257 9.73716 14.0234 10.0248 13.7358L13.5673 10.1933C13.8571 9.90345 13.8571 9.43354 13.5673 9.14368C13.2774 8.85381 12.8075 8.85381 12.5176 9.14368Z",
    fill: "#0E6F1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.59375C4.57789 0.59375 0.59375 4.57722 0.59375 9.5C0.59375 14.4221 4.57718 18.4062 9.5 18.4062C14.4221 18.4062 18.4062 14.4228 18.4062 9.5C18.4062 4.57789 14.4228 0.59375 9.5 0.59375ZM9.5 16.9219C5.40758 16.9219 2.07812 13.5924 2.07812 9.5C2.07812 5.40758 5.40758 2.07812 9.5 2.07812C13.5924 2.07812 16.9219 5.40758 16.9219 9.5C16.9219 13.5924 13.5924 16.9219 9.5 16.9219Z",
    fill: "#0E6F1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_16840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2da444cca833c12f782b953539104557.svg";
export { ForwardRef as ReactComponent };